import React, { useState, useEffect } from 'react';
import { motion, useScroll, useTransform } from 'framer-motion';
import HeroSection from './sections/HeroSection';
import WhyDatadogSection from './sections/WhyDatadogSection';
import CareerTimelineSection from './sections/CareerTimelineSection';
import AwardsSection from './sections/AwardsSection';
import EducationSection from './sections/EducationSection';
import ContactSection from './sections/ContactSection';
import Navigation from './Navigation';

const Portfolio = () => {
  const { scrollYProgress } = useScroll();
  const opacity = useTransform(scrollYProgress, [0, 0.2], [0.95, 0.85]);

  return (
    <div className="relative" style={{ background: 'linear-gradient(135deg, #30229E 0%, #5D3FD3 50%, #CE40CB 100%)' }}>
      <Navigation />
      
      <motion.div 
        className="fixed inset-0 z-0 pointer-events-none"
        style={{
          background: 'linear-gradient(135deg, #30229E 0%, #5D3FD3 50%, #CE40CB 100%)',
          opacity
        }}
      />

      <div className="relative z-10">
        <HeroSection />
        <WhyDatadogSection />
        <CareerTimelineSection />
        <AwardsSection />
        <EducationSection />
        <ContactSection />
      </div>

      <footer className="relative z-10 bg-[#2A1F5E]/60 backdrop-blur-md border-t border-white/10 py-8">
        <div className="max-w-7xl mx-auto px-4 text-center">
          <p className="text-white/70 text-sm font-mono">
            © 2025 Vaibhav Vishnu. Built with React + FastAPI.
          </p>
        </div>
      </footer>
    </div>
  );
};

export default Portfolio;